import useWorkflowNavigation from '@/frontend/pages/Dashboard/Workflows/useWorkflowNavigation'
import { router } from '@inertiajs/react'
import { useEffect, useState, type FormEvent } from 'react'
import { Loader2, Search } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import BlockState from '@/frontend/pages/Dashboard/Workflows/BlockState'
import type { Copy, ServiceError } from '@/frontend/pages/Dashboard/Workflows/types'

export default function ExecutionLookup({ query, error, copy }: { query: string; error: ServiceError | null; copy: Copy }) {
  const { lookupPath } = useWorkflowNavigation()
  const [id, setId] = useState(query)
  const [processing, setProcessing] = useState(false)
  useEffect(() => { setId(query) }, [query])
  function submit(event: FormEvent) {
    event.preventDefault()
    if (processing || !id.trim()) return
    router.get(lookupPath(id.trim()), {}, { onStart: () => setProcessing(true), onFinish: () => setProcessing(false) })
  }
  return <section className="space-y-3" aria-busy={processing}>
    <form onSubmit={submit} className="space-y-3">
      <Label htmlFor="workflow-execution-id" className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{copy.lookup.title}</Label>
      <div className="flex flex-col gap-2 sm:flex-row"><div className="relative min-w-0 flex-1">
        <Search className="pointer-events-none absolute left-3 top-1/2 size-3.5 -translate-y-1/2 text-muted-foreground" aria-hidden />
        <Input id="workflow-execution-id" name="execution_id" value={id} required disabled={processing} placeholder={copy.lookup.placeholder}
          autoComplete="off" aria-describedby="workflow-execution-hint" className="h-10 pl-9 font-mono text-xs" onChange={(event) => setId(event.target.value)} />
      </div><Button type="submit" className="h-10 bg-foreground text-background hover:bg-foreground/90" disabled={processing || !id.trim()}>
        {processing && <Loader2 className="size-3.5 animate-spin" aria-hidden />}{processing ? copy.lookup.submitting : copy.lookup.submit}
      </Button></div>
      <p id="workflow-execution-hint" className="text-xs leading-relaxed text-muted-foreground">{copy.lookup.hint}</p>
    </form>
    <BlockState error={error} copy={copy} />
  </section>
}
